<template>
  <div class="page-container" ref="Home" id="homecontainer">
    <div class="bigscroller">
      <Menu />
      <MobileMenu />
      <section id="home">
        <span class="top watcher" v-observe-visibility="visibilityChanged"></span>
        <Hero />
        <span class="bottom watcher" v-observe-visibility="visibilityChanged"></span>
      </section>
      <section id="lacerveza">
        <span class="top watcher" v-observe-visibility="visibilityChanged"></span>
        <TheBeer />
        <span class="bottom watcher" v-observe-visibility="visibilityChanged"></span>
      </section>
      <section id="herencia">
        <span class="top watcher" v-observe-visibility="visibilityChanged"></span>
        <OurHeritage />
        <span class="bottom watcher" v-observe-visibility="visibilityChanged"></span>
      </section>
      <section id="highlifehoy">
        <span class="top watcher" v-observe-visibility="visibilityChanged"></span>
        <HighLifeNow />
      </section>
      <section id="momentshighlife">
        <span class="top watcher" v-observe-visibility="visibilityChanged"></span>
        <MomentsHighLife />
      </section>
      <section id="retailers">
        <span class="top watcher" v-observe-visibility="visibilityChanged"></span>
        <Retailers />
      </section>
      <div class="footer-container">
        <div class="age-gate-footer">
          <div class="logo-in-footer">
            <img :src="mhlcenteredlogoImage" alt class="footer-logo" />
          </div>
          <div class="footer-titles">
            <div class="privacy-container">
              <h4 class="privacy" @click="$router.push('/tycos')">términos y condiciones</h4>
              <h4 class="privacy bar">|</h4>
              <h4 class="privacy" @click="$router.push('/politics')">política de privacidad</h4>
              <h4 class="privacy bar">|</h4>
              <h4 class="privacy" @click="$router.push('/cookies')">política de cookies</h4>
              <h4 class="privacy bar">|</h4>
              <h4 class="privacy desktop nohover">evita el exceso - producto para mayores de 18 años</h4>
              <h4 class="privacy mobile nohover">
                evita el exceso
                <br />producto para mayores de 18 años
              </h4>
            </div>

            <div class="footer-subtitle">
              <p>© 2020 Coors Brewing Co. Y ™/® Propiedad de Coors Brewing Company, Denver, CO USA.</p>
            </div>
          </div>
          <div class="number-in-footer">
            <a href="tel:8002378392" @click="onClickOptionsPush()">
              <img alt="contact" :src="phonenumberImage" class="footer-logo" />
            </a>
            <!--<img :src="phonenumberImage" alt class="footer-logo" />-->
          </div>
        </div>
        <Modal v-if="showModal" v-bind:wichModal="wichModal" @close="showModal = false" />
      </div>
    </div>
  </div>
</template>

<script>
import Parallax from "vue-parallaxy";
import Hero from "@/components/Hero";
import TheBeer from "@/components/TheBeer";
import OurHeritage from "@/components/OurHeritage";
import HighLifeNow from "@/components/HighLifeNow";
import MomentsHighLife from "@/components/MomentsHighLife";
import Retailers from "@/components/Retailers";

import Menu from "@/components/Menu";
import MobileMenu from "@/components/MobileMenu";
import Modal from "@/components/Modal";

import parallaxer from "../assets/parallaxer.jpeg";

import mhlcenteredlogo from "@/assets/miller-high-life-centered-logo.png";
import phonenumber from "@/assets/800CERVEZA.png";

import VueScrollTo from "vue-scrollto";

import { mapActions, mapGetters } from "vuex";

//Implementar tag
import tagFunctions from '../utils/tagFunctions';

export default {
  name: "Home",
  props: ["id"],
  components: {
    Hero,
    Parallax,
    TheBeer,
    OurHeritage,
    HighLifeNow,
    MomentsHighLife,
    Retailers,
    Menu,
    MobileMenu,
    Modal
  },
  computed: {
    ...mapGetters([
      "getActiveSection",
      "getTriggerSpring",
      "getEdgeScrolling",
      "getScrollMotion"
    ])
  },
  created() {},
  data() {
    return {
      showModal: false,
      wichModal: "terms",
      fixedLel: true,
      parallaxerImage: parallaxer,
      mhlcenteredlogoImage: mhlcenteredlogo,
      phonenumberImage: phonenumber,
      placesDirections: {
        heroUp: () => {
          this.setActiveSection("lacerveza");
        },
        heroDown: scrolled => {
          this.setActiveSection("lacerveza");
          document.getElementById("app").scroll(0, scrolled);
        },
        lacervezaUp: scrolled => {
          this.setActiveSection("hero");
          document.getElementById("app").scroll(0, scrolled);
        },
        lacervezaDown: scrolled => {
          this.setActiveSection("herencia");
          document.getElementById("app").scroll(0, scrolled);
        },
        herenciaUp: scrolled => {
          this.setActiveSection("lacerveza");
          document.getElementById("app").scroll(0, scrolled);
        },
        herenciaDown: scrolled => {
          this.setActiveSection("highlifehoy");
          document.getElementById("app").scroll(0, scrolled);
        },
        highlifehoyUp: scrolled => {
          this.setActiveSection("herencia");
          document.getElementById("app").scroll(0, scrolled);
        },
        highlifehoyDown: () => {
          console.log("");
        }
      }
    };
  },
  mounted() {
    this.checkRouteForInitialScroll();
    //Implementar tag 
    tagFunctions.evPageViewPush('Home');
  },
  methods: {
    ...mapActions({
      goToSection: "goToSection",
      setActiveSection: "setActiveSection",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setEdgeScrollingAction: "setEdgeScrolling"
    }),
    //Implementar tag Click over options
    onClickOptionsPush() {
      tagFunctions.evClickOptionsPush("click_to_call")
    },
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        this.$router.push({ path: entry.target.offsetParent.id });
        this.setActiveSection({
          willSroll: false,
          section: entry.target.offsetParent.id
        });
      }
    },
    checkRouteForInitialScroll() {
      let route = this.$route.path.replace("/", "");
      if (route != "") {
        VueScrollTo.scrollTo(`#${route}`, 1, {
          container: "#app",
          easing: "linear",
          offset: 0,
          force: true,
          cancelable: true,
          onStart: function(element) {},
          onDone: function(element) {},
          onCancel: function() {},
          x: false,
          y: true
        });
      }
    },
    scrollToSection(section) {
      VueScrollTo.scrollTo(`#${section}`, 200, {
        container: "#app",
        easing: "ease-in",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: function(element) {
          // scrolling started
        },
        onDone: function(element) {
          // scrolling is done
        },
        onCancel: function() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/home.scss";
@import "~@/styles/variables.scss";
</style>
